module.exports = __webpack_public_path__ + "static/img/3_1_2.7f5d8900.jpg";